import React from 'react';

function Health() {
	return (
		<h1> OK! </h1>
	);
}

export default Health;
